export default __webpack_public_path__ + "static/media/contact-me.73c2fecc.png";